import React, {useEffect, useState} from 'react';
import {Helmet} from "react-helmet";
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
import RegistrationForm from '../components/common/RegistrationForm'
import FeaturesSideBySide from '../components/features/FeaturesSideBySide'
import MaltaFeatures from '../components/features/MaltaFeatures'
import Team from '../components/team/Team'
import Pricing from '../components/pricing/Pricing'
import Testimonials from '../components/testimonials/Testimonials'
import Security from '../components/security/Security'

import PayslipSampleGenerator from '../components/common/PayslipSampleGenerator'

import MaltaFlag from '../assets/flags/malta.svg';

import mcDonaldsLogo from '../assets/images/mc-donalds.png';
import sixteenLogo from '../assets/images/sixteen.png';
import myokaLogo from '../assets/images/myoka.png';
import skySpiritLogo from '../assets/images/sky-spirit.png';
import ReactMarkdown from 'react-markdown'


import MarkdownContent from '../content/payslip.md';
import gfm from 'remark-gfm'
import math from 'remark-math'
import frontmatter from 'remark-frontmatter'
const { parseMarkdownFrontmatter } = require('../utils/safeFrontmatter');


function Home({

}) {

  const [markdown, setMarkdown] = useState(null)
  const [yamlProperties, setYamlProperties] = useState(null)

  useEffect(() => {
    fetch(MarkdownContent).then(res => res.text()).then(text => {
      setMarkdown(text)
      setYamlProperties(parseMarkdownFrontmatter(text))
    });
  },[]);

  return (

    <React.Fragment>

      <Helmet>
          <title>{yamlProperties && yamlProperties.seoTitle}</title>
          <meta name="description" content={yamlProperties?.description} />
          <link rel="canonical" href={yamlProperties && yamlProperties.canonical} />
      </Helmet>
      <main className="mt-8 sm:mt-16 md:mt-20 lg:mb-24 mb-8 sm:mb-16 md:mb-20 lg:mb-24">
        <div className="mx-auto max-w-screen-xl">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
              <div>
                <h1 className="mt-4 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                  {yamlProperties && yamlProperties.titleLine1}
                  <br className="hidden md:inline"/>
                  <span className="text-orange-400">{yamlProperties && yamlProperties.titleLine2}</span>
                </h1>
                <ReactMarkdown 
                  children={yamlProperties && yamlProperties.intro} 
                  components={{
                    p: ({children}) => (
                      <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                        {children}
                      </p>
                    )
                  }}
                />
                
              </div>
            </div>
            <div className="mt-12 sm:mt-16 lg:mt-0 lg:col-span-6">
              {/*<PayslipSampleGenerator/>*/}
            </div>
          </div>
        </div>
      </main>
      
      <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 space-y-8 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-start">
            <div className="relative z-10">
              <div className="prose prose-orange text-gray-500 mx-auto lg:max-w-none">
                <ReactMarkdown 
                  children={markdown} 
                  remarkPlugins={[gfm,math,[frontmatter, ['yaml','toml']]]}
                />
              </div>
              {/*<div className="mt-10 flex text-base max-w-prose mx-auto lg:max-w-none">
                <div className="rounded-md shadow">
                  <a href="#" className="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-orange-600 hover:bg-orange-700">
                    Contact sales
                  </a>
                </div>
                <div className="rounded-md shadow ml-4">
                  <a href="#" className="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-orange-600 bg-white hover:bg-gray-50">
                    Learn more
                  </a>
                </div>
              </div>*/}
            </div>
            <div className="mt-12 relative text-base max-w-prose mx-auto lg:mt-0 lg:max-w-none" style={{height: "100%"}}>

              <svg className="absolute top-0 right-0 -mt-12 -mr-20 lg:top-auto lg:right-auto lg:bottom-1/2 lg:left-1/2 lg:mt-0 lg:mr-0 xl:top-0 xl:right-0 xl:-mt-12 xl:-mr-20" width="404" height="384" fill="none" viewBox="0 0 404 384" aria-hidden="true">
                <defs>
                  <pattern id="bedc54bc-7371-44a2-a2bc-dc68d819ae60" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                    <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
                  </pattern>
                </defs>
                <rect width="404" height="384" fill="url(#bedc54bc-7371-44a2-a2bc-dc68d819ae60)" />
              </svg>

              <div className="sticky" style={{top: 10}}>
                <PayslipSampleGenerator/>
              </div>

              {/*<blockquote style={{top: 10}} className="mt-15 sticky bg-white rounded-lg shadow-lg">
                <div className="rounded-t-lg px-6 py-8 sm:px-10 sm:pt-10 sm:pb-8">
                  <img src="https://tailwindui.com/img/logos/workcation-logo-orange-600-mark-gray-800-and-orange-600-text.svg" alt="Workcation" className="h-8"/>
                  <div className="relative text-lg text-gray-700 font-medium mt-8">
                    <svg className="absolute top-0 left-0 transform -translate-x-3 -translate-y-2 h-8 w-8 text-gray-200" fill="currentColor" viewBox="0 0 32 32" aria-hidden="true">
                      <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                    </svg>
                    <p className="relative">Tincidunt integer commodo, cursus etiam aliquam neque, et. Consectetur pretium in volutpat, diam. Montes, magna cursus nulla feugiat dignissim id lobortis amet. Laoreet sem est phasellus eu proin massa, lectus.</p>
                  </div>
                </div>
                <cite className="relative flex items-center sm:items-start bg-orange-600 rounded-b-lg not-italic py-5 px-6 sm:py-5 sm:pl-12 sm:pr-10 sm:mt-10">
                  <div className="relative rounded-full border-2 border-white sm:absolute sm:top-0 sm:transform sm:-translate-y-1/2">
                    <img className="w-12 h-12 sm:w-20 sm:h-20 rounded-full bg-orange-300" src="https://images.unsplash.com/photo-1500917293891-ef795e70e1f6?ixlib=rb-1.2.1&amp;auto=format&amp;fit=facearea&amp;facepad=2.5&amp;w=160&amp;h=160&amp;q=80" alt=""/>
                  </div>
                  <span className="relative ml-4 text-orange-300 font-semibold leading-6 sm:ml-24 sm:pl-1">
                    <p className="text-white font-semibold sm:inline">Judith Black</p>
                    <p className="sm:inline">CEO at Workcation</p>
                  </span>
                </cite>
              </blockquote>*/}
            </div>
          </div>
        </div>
      </div>


      <div className="bg-orange-700">
        <div className="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
            <span className="block">Say hello to easy payslips.</span>
            <span className="block">Start using Buddy today.</span>
          </h2>
          <p className="mt-4 text-lg leading-6 text-orange-200">Buddy has Malta's easiest to understand payslips. <br/>It's super easy to use with no previous experience required.</p>
          <Link to="/" className="mt-8 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-orange-600 bg-white hover:bg-orange-50 sm:w-auto">
            Try Buddy for free
          </Link>
        </div>
      </div>

    </React.Fragment>
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home) 
